// src/config/creditCosts.js
const creditCosts = {
    CREATE_RACER: 3,
    CREATE_EVENT: 20,
  };
  
  export default creditCosts;